import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { LOGIN } from '@/constants/testIds';
import { Loader2 } from 'lucide-react';
import { GoogleButton, OrDivider } from '@/components/GoogleButton';

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      nav('/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not sign in');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <h1 className="font-serif-display text-4xl text-[#1A2421] font-medium text-center leading-tight">Welcome back</h1>
        <p className="text-center text-[#4A5A53] mt-3 font-light">Sign in to see your Wellth history.</p>

        <form onSubmit={submit} className="mt-10 bg-white border border-[#E5E1D8] rounded-2xl p-8 space-y-5">
          <GoogleButton testId="login-google-button" />
          <OrDivider />
          <div>
            <Label htmlFor="email" className="text-xs tracking-[0.2em] uppercase font-semibold text-[#4A5A53]">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 h-12 bg-white border-[#E5E1D8] rounded-xl" data-testid={LOGIN.emailInput} />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs tracking-[0.2em] uppercase font-semibold text-[#4A5A53]">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 h-12 bg-white border-[#E5E1D8] rounded-xl" data-testid={LOGIN.passwordInput} />
          </div>
          <Button disabled={loading} type="submit" className="w-full rounded-full bg-[#4A7C59] hover:bg-[#3E6B4F] text-white h-12" data-testid={LOGIN.submitButton}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign in'}
          </Button>
          <p className="text-center text-sm text-[#4A5A53]">
            New to Wellth?{' '}
            <Link to="/signup" className="text-[#4A7C59] font-semibold hover:underline" data-testid={LOGIN.registerLink}>Create account</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
